export default "__VITE_ASSET__Xgq5waGB__"